import React from "react";

import { Visibility, VisibilityOff } from "@mui/icons-material";
import { TextField } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import { styled as st } from "@mui/material/styles";
import { IconButton } from "../../IconButton";
import { TextFieldColor, TextInputProps } from "./types";

export const TextInput = ({
  value = "",
  label = "",
  size = "medium",
  variant = "outlined",
  required = false,
  fullWidth = false,
  type = "text",
  handleChange,
  startAdornment,
  endAdornment = false,
  isValid = true,
  onBlur,
  dirty = false,
  color = undefined,
}: TextInputProps) => {
  const [values, setValues] = React.useState({
    showPassword: type !== "password",
  });

  const isPasswordType = () => {
    return type === "password";
  };

  // https://codesandbox.io/s/unruffled-lamport-m9wpy8?file=/demo.tsx:1058-1316
  // https://mui.com/material-ui/react-text-field/
  // https://codesandbox.io/s/31fzwh?file=/demo.tsx
  return (
    <StyledTextField
      variant={variant as any}
      size={size as any}
      fullWidth={fullWidth}
      error={dirty && isValid === false}
      value={value}
      colorProp={color}
      onChange={handleChange}
      onBlur={onBlur}
      label={label}
      type={values.showPassword ? "text" : "password"}
      required={required}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
        input: {
          // notched: false, //remove border space for the label text => could be useful for situations where the label is not wanted
          endAdornment:
            endAdornment && isPasswordType() ? (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={() =>
                    setValues({ showPassword: !values.showPassword })
                  }
                >
                  {values.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ) : null,
        },
      }}
    />
  );
};

const StyledTextField = st(TextField, {
  shouldForwardProp: (prop) => prop !== "colorProp", // Prevent `borderColor` from being passed to the DOM
})<TextFieldColor>(({ colorProp }) => ({
  "& label": {
    color: colorProp || "var(--color-white)",
  },
  "& label.Mui-focused": {
    color: colorProp || "var(--color-white)",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "black",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "var(--color-gray-100)",
    },
    "&:hover fieldset": {
      // borderColor: 'yellow',
    },
    "&.Mui-focused fieldset": {
      borderColor: "black",
    },
    input: {
      color: colorProp || "var(--color-white)",
    },
  },
}));
